module.exports = __webpack_public_path__ + "static/colors-identity-do-dae097d8723a1b72a12fcd03eae37e8f.png";